<template>
  <div class="container">
    <div class="row" style="margin: 40px 0 20px 0">
      <div class="col-md-4 col-sm-4 col-md-offset4 col-sm-offset4">
        <div class="text-center" >
          <img width="240" src="./assets/logo-filled.png" alt="TPaaS Outlook Add-In" title="TPaaS Outlook Add-In" />
          <h3>{{ $t('title') }}</h3>
        </div>
      </div>
    </div>

    <div class="row" style="margin: 10px 0" v-if="mounted">
      <Login v-if="!isLogged"
          v-on:logged="logged"
          v-on:loginerror="showMessage"
      />

      <Meeting v-if="isLogged"
        :can_record="can_record"
        :username="username"
        :password="password"
        :contacts="contacts"
        :vmrs="vmrs"
        v-on:logout="logout"
        v-on:message="showMessage"
      />

      <Message v-if="show_message" :message="message" :type="type" style="margin-top:10px;" />
    </div>
  </div>
</template>

<script>
import Login from './components/Login'
import Meeting from './components/Meeting'
import Message from './components/Message'
import addinConfig from './helpers/addin-config.js'
import tpaas from './helpers/tpaas.js'

export default {
  name: 'App',
  data: function() {
    return  {
      mounted: false,
      can_record: false,
      username: null,
      password: null,
      isLogged: false,
      contacts: [],
      vmrs: [],
      message: null,
      type: 'danger',
      show_message: false
    }
  },
  components: {
    Login,
    Meeting,
    Message
  },
  mounted: function () {
    let config = addinConfig.getConfig();
    var self = this;
    if (config.username && config.password) {
      this.$root.$i18n.locale = config.locale;
      tpaas.doLogin(config.username, config.password, this.$root.$i18n.locale)
      .then(function (data) {
        if (data.result == "ok")
          self.logged(data);
          self.username = config.username;
          self.password = config.password;
          self.mounted = true;
      })
      .catch(function (message) {
        self.showMessage(message);
        addinConfig.eraseConfig();
        self.mounted = true;
      });
    } else {
      self.mounted = true;
    }
  },
  methods: {
    logged(data, username, password) {
      this.can_record = data.canRecord;
      this.contacts = data.contacts;
      this.vmrs = [ { id: -1, nombre: this.$t('random_room')}];
      this.vmrs = this.vmrs.concat(data.vmrs);
      this.isLogged = true;
      this.username = username;
      this.password = password;
      this.hideMessage();
    },
    logout(){
      this.isLogged = false;
      this.contacts = [];
      this.vmrs = [];
      this.can_record = false;
    },
    showMessage(message, type) {
      this.show_message = true;
      this.message = message;
      this.type=type;
      setTimeout(this.hideMessage, 5 * 1000);
    },
    hideMessage() {
      this.show_message = false;
      this.type = 'danger';
      this.message = '';
    }
  }
}
</script>

<style src="bootstrap/dist/css/bootstrap.min.css"></style>


// WEBPACK FOOTER //
// src/App.vue